import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";

export class MessageLogService {
    static async getLogs(params: { page?: number; limit?: number; channel?: string; status?: string; to?: string }) {
        const query = new URLSearchParams();
        if (params.page) query.set("page", String(params.page));
        if (params.limit) query.set("limit", String(params.limit));
        if (params.channel) query.set("channel", params.channel);
        if (params.status) query.set("status", params.status);
        if (params.to) query.set("to", params.to);
        return await makeRequest(`${url.messageLogs.getLogs}?${query.toString()}`, RequstMethods.GET);
    }
}
